import {
  PerformanceMetricsCashflow,
  PerformanceMetricsProfitAndLoss,
  PerformanceMetricsBalanceSheet,
  PerformanceMetricsBusinessInsights
} from '@futrli-sdk/predict';
import { API_PATHS, interpolatePathParams, ROUTE_PARAMS } from '@futrli/shared-services';
import { QueryParams } from '../types';
import { makeRequestWithResponse } from './shared';

/**
 * Fetch Performance Metrics Cashflow
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get plays from
 * @returns {Promise<>} - Returns forecast data
 * @throws error
 */
export const fetchPerformanceMetricsCashflow = async (
  workspaceId: string,
  organisationId: string
): Promise<PerformanceMetricsCashflow> => {
  const path = interpolatePathParams(API_PATHS.PERFORMANCE_MERTICS_CASHFLOW, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<PerformanceMetricsCashflow>({ url: path });
};

export const fetchBusinessInsightsMetrics = async (
  workspaceId: string,
  organisationId: string,
  queryParams: QueryParams = {}
): Promise<PerformanceMetricsBusinessInsights> => {
  const path = interpolatePathParams(API_PATHS.BUSINESS_INSIGHTS_METRICS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<PerformanceMetricsBusinessInsights>({ url: path, params: queryParams });
};

/**
 * Fetch Performance Metrics Profit And Loss
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get plays from
 * @returns {Promise<>} - Returns forecast data
 * @throws error
 */
export const fetchPerformanceMetricsProfitAndLoss = async (
  workspaceId: string,
  organisationId: string
): Promise<PerformanceMetricsProfitAndLoss> => {
  const path = interpolatePathParams(API_PATHS.PERFORMANCE_MERTICS_PROFIT_AND_LOSS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<PerformanceMetricsProfitAndLoss>({ url: path });
};

/**
 * Fetch Performance Metrics Balance Sheet
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get plays from
 * @returns {Promise<>} - Returns forecast data
 * @throws error
 */
export const fetchPerformanceMetricsBalanceSheet = async (
  workspaceId: string,
  organisationId: string
): Promise<PerformanceMetricsBalanceSheet> => {
  const path = interpolatePathParams(API_PATHS.PERFORMANCE_MERTICS_BALANCE_SHEET, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<PerformanceMetricsBalanceSheet>({ url: path });
};
